import { encodeData } from '@airtel/air-utils';
import { isMobileApp, isNewIOSApp, getAnalyticsParams, makeDigitalStorePayment } from '@airtel-lego/native-app-bridge';
import { getBaseHref } from '../common/environment';

const removeBlankAttributes = (obj: Record<string, any>) => {
  const result: Record<string, string> = {};
  for (const key in obj) {
    const val = obj[key];
    if (val !== undefined && val !== null && val !== '') {
      result[key] = typeof val === 'string' ? val : String(val);
    }
  }
  return result;
};

export const navigateToPaymentQC = async (onUserAction: any, localData: any, getState: any) => {
  const lob = 'CART_ECOM';
  const { storeValues } = getState();

  const msisdn = storeValues?.appData?.msisdn;

  const payableAmountStore = storeValues?.paymentContext?.paymentAmount;
  let payableAmount = payableAmountStore !== undefined && payableAmountStore !== null ? String(payableAmountStore) : '';

  let serviceId = storeValues?.paymentContext?.PaymentType;
  const referenceOrderId = storeValues?.cartContext?.cartId;
  const orderItemId = storeValues?.cartContext?.cartItemId;
  const subLob = storeValues?.appData?.subLob || '';
  const extraData1 = storeValues?.analyticsContext?.ed1 || '';

  const search = window.location.search;
  const params = new URLSearchParams(search);

  const utm_layout = params.get('utm_layout') || 'common_bundling_otp_shift';
  const utm_source = params.get('utm_source') || '';
  const utm_campaign = params.get('utm_campaign') || '';
  const utm_medium = params.get('utm_medium') || '';

  const cancelUrlObj = new URL(window.location.href);
  const BASE_HREF = getBaseHref();
  const pathName = window?.location?.pathname || '';
  const landingLayoutOverride = window?.sessionStorage?.getItem('ps_landingLayoutName');

  const smsRedirectionLOB = 'sms_sent';
  const name = storeValues?.cartContext?.name || '';

  let journey = params.get('journey') || '';

  // cartContext.address might be a string or an object with street1/city
  const rawAddress = storeValues?.cartContext?.address || '';
  const address =
    typeof rawAddress === 'string'
      ? rawAddress
      : rawAddress?.street1 || rawAddress?.line1 || '';
  const city =
    typeof rawAddress === 'string'
      ? ''
      : rawAddress?.city || '';

  const isApp = isMobileApp();
  const QcSubtitle = storeValues?.cartContext?.qcSubtitle || 'Postpaid';
  const planPrice = storeValues?.cartContext?.planPrice || '';
  const benefit1 = storeValues?.cartContext?.benefit1 || '';
  const benefit2Heading = storeValues?.cartContext?.benefit2Heading || '';
  const benefit2SubHeading = storeValues?.cartContext?.benefit2SubHeading || '';

  const transactionText =
    'Postpaid advance amount' + (msisdn ? ` | ${msisdn}` : '');

  let tempPrimaryHeading = planPrice ? `₹${planPrice} Plan` : '';
  if (benefit1) tempPrimaryHeading += ` - ${benefit1}`;
  if (benefit2Heading && benefit2SubHeading) {
    tempPrimaryHeading += ` · ${benefit2Heading} ${benefit2SubHeading}`;
  }
  const primaryHeading = tempPrimaryHeading || '';
  const subHeading = address ? `Billing address - ${address}` : '';

  const urlParams: { [name: string]: any } = {
    mobileNumber: msisdn,
    journey,
    orderItemId,
    payableAmount,
    orderId: referenceOrderId,
    utm_layout,
    utm_source,
    utm_campaign,
    utm_medium,
    appointmentSubLob: subLob,
  };

  const linkRedirectionUrlParams: { [name: string]: any } = {
    lob: smsRedirectionLOB,
    orderId: referenceOrderId,
    mobileNumber: msisdn,
    orderItemId,
    utm_source,
    utm_layout,
    utm_campaign,
    utm_medium,
  };

  const urlSearchParams = new URLSearchParams(removeBlankAttributes(urlParams));
  const linkRedirectionUrlParamsSearchParams = new URLSearchParams(
    removeBlankAttributes(linkRedirectionUrlParams)
  );

  const cancelUrl = cancelUrlObj.href;

  // Thank-you / loader URLs (aligned with existing postpaid payment util)
  let thankYouPageUrl = `https://${window.location.hostname}${BASE_HREF}/thank-you?mobileNumber=${msisdn || ''}&journey=${journey ||
    ''}&orderItemId=${orderItemId || ''}&landingLayoutOverride=${landingLayoutOverride || ''}`;

  if (pathName.includes('parent-order-summary-new')) {
    journey = 'P2P';
    thankYouPageUrl = `https://${window.location.hostname}${BASE_HREF}/p2p-payment-loader?mobileNumber=${msisdn ||
      ''}&journey=${journey}&orderItemId=${orderItemId ||
      ''}&landingLayoutOverride=${landingLayoutOverride || ''}`;
  }

  if (pathName.includes('child-order-summary-new')) {
    const childPaymentAmount = storeValues?.childPaymentContext?.paymentAmount;
    const childPaymentType = storeValues?.childPaymentContext?.paymentType;

    if (childPaymentAmount !== undefined && childPaymentAmount !== null) {
      payableAmount = String(childPaymentAmount);
    }
    if (childPaymentType) {
      serviceId = childPaymentType;
    }

    thankYouPageUrl = `https://${window.location.hostname}${BASE_HREF}/payment-loader?mobileNumber=${msisdn ||
      ''}&journey=${journey || ''}&orderItemId=${orderItemId ||
      ''}&landingLayoutOverride=${landingLayoutOverride || ''}`;
  }

  const linkRedirectionUrl = `https://${window.location.hostname}${BASE_HREF}/thanks?${linkRedirectionUrlParamsSearchParams.toString()}`;

  let thankYouPageUrlDeepLink = `myairtel://webview?au=${encodeURIComponent(
    thankYouPageUrl
  )}`;
  if (isNewIOSApp()) {
    thankYouPageUrlDeepLink = `myairtel://webview?ax=${encodeURIComponent(
      thankYouPageUrl
    )}`;
  }

  const fullCheckoutPayload = createFullCheckoutPayload(
    lob,
    msisdn, // provisionSi
    cancelUrl,
    payableAmount, // totalPaymentPrice (string)
    thankYouPageUrl,
    serviceId,
    '',
    referenceOrderId, // COM order Id
    msisdn, // rtn
    linkRedirectionUrl,
    name, // Added for journeyType = agent and used in SMS when sent to users
    utm_source,
    utm_campaign,
    utm_medium,
    /* journeyType */ undefined,
    referenceOrderId,
    extraData1,
    address,
    city,
    orderItemId,
    transactionText,
    primaryHeading,
    subHeading
  );

  const quickCheckoutPayload = createQuickCheckoutPayload(
    payableAmount,
    thankYouPageUrlDeepLink,
    msisdn,
    referenceOrderId,
    QcSubtitle,
    utm_source,
    utm_campaign,
    utm_medium,
    extraData1,
    address,
    city,
    orderItemId
  );

   const paymentPayload = async () => {
    if (isApp) {
      const { appNumber } = (await getAnalyticsParams()) || {};

      if (isNewIOSApp()) {
        if (appNumber > 964) {
          // Use Quick Checkout on supported iOS app versions
          makeDigitalStorePayment(quickCheckoutPayload);
          return '';
        }
        return fullCheckoutPayload;
      } else {
        if (appNumber > 5714) {
          // Use Quick Checkout on supported Android app versions
          makeDigitalStorePayment(quickCheckoutPayload);
          return '';
        }
        return fullCheckoutPayload;
      }
    }

    // Web fallback → full checkout
    return fullCheckoutPayload;
  };

  const payload = await paymentPayload();

  if (payload !== '') {
    sessionStorage.setItem('paymentPayload', payload);
    let url = `https://${window.location.hostname}/pay/?payloadData=${payload}`;

    sessionStorage.setItem('paymentPayloadUrl', url);

    return onUserAction?.({
      actions: [
        {
          payload: {
            args: [],
            utilName: 'resetOnWebViewCloseCallback',
          },
          type: 'callUtilFunction',
        },
        {
          type: 'navigation',
          payload: { externalUrl: url },
        },
      ],
    });
  } else {
    return onUserAction({
      actions: [],
    });
  }
};

export const createFullCheckoutPayload = (
  lob: string,
  provisionSi: string,
  cancelUrl: string,
  price: string,
  thankYouPageUrl: string,
  serviceId: string,
  additionalInfo?: any,
  orderId?: string,
  rtn?: string,
  linkRedirectionUrl?: string,
  name?: string,
  utm_source?: string,
  utm_campaign?: string,
  utm_medium?: string,
  journeyType?: string,
  referenceOrderId?: string,
  extraData1?: string,
  address?: string,
  city?: string,
  orderItemId?: string,
  transactionText?: string,
  primaryHeading?: string,
  subHeading?: string
) => {
  const paymentObj = {
    lobData: {
      productCategory: 'P2P',
    },
    order: {
      ...(orderId && { orderId }),
      lobName: lob,
      serviceInstance: provisionSi,
      paymentAmount: price,
      benefitAmount: price,
      saveCard: false,
      ...(additionalInfo && {
        additionalInfo,
      }),
      name: name,
    },
    billSummary: {
      paymentAmount: price,
      transactionText: transactionText,
      primaryHeading: primaryHeading,
      subHeading: [subHeading],
      detailSection: [
        {
          key: serviceId,
          value: `₹${price}`,
        },
      ],
    },
    callBack: {
      redirectionUrl: thankYouPageUrl,
      cancelUrl,
    },
    channelInfo: {
      encodedParams: false,
    },
    customElements: {
      notes: [
        'You can modify the selected plan before bill generation.',
        'If you cancel, the full amount you paid will be refunded.',
      ],
      removeBackButton: true,
    },
    flow: {
      isAuthFlow: false,
      ...(rtn && {
        trackingObj: {
          eVar6: rtn,
          extraData20: journeyType,
          eVar26: 'modular_postpaid_purchase',
          eVar21: rtn,
          utm_source: utm_source,
          utm_campaign: utm_campaign,
          utm_medium: utm_medium,
          eVar8: referenceOrderId,
          prop13: address,
          extraData12: orderItemId,
          city: city,
          extraData1: extraData1,
        },
      }),
    },
  };
  return encodeData(paymentObj);
};

export const createQuickCheckoutPayload = (
  price: string,
  thankYouPageUrlDeepLink: string,
  rtn?: string,
  referenceOrderId?: string,
  QcSubtitle?: string,
  utm_source?: string,
  utm_campaign?: string,
  utm_medium?: string,
  extraData1?: string,
  address?: string,
  city?: string,
  orderItemId?: string
) => {
  const numericPrice = Number(price) || 0;

  const trackingObj = {
    eVar6: rtn,
    eVar26: 'modular_postpaid_purchase',
    eVar21: rtn,
    utm_source: utm_source || '',
    utm_campaign: utm_campaign || '',
    utm_medium: utm_medium || '',
    eVar8: referenceOrderId,
    prop13: address,
    extraData12: orderItemId,
    city,
    extraData1: extraData1 || '',
  };

  const paymentObj = {
    checkoutSdk: {
      totalAmount: price, // amount
      number: rtn, // rtn
      undiscountedAmount: price, // same as total amount
      subtitle: [QcSubtitle || 'Postpaid', rtn || ''],
      paymentLob: 'CART_ECOM',
      siNumber: rtn,
      productCategory: 'P2P',
      order: {
        request: {},
        response: {
          data: {
            orderId: referenceOrderId,
            orderAmountBreakup: {
              totalAmount: price,
              undiscountedAmount: price,
              subtitle: [QcSubtitle || 'Postpaid', rtn || ''],
              isGST: false,
              breakupInfo: [
                {
                  type: 'DEFAULT',
                  title: QcSubtitle || 'Postpaid',
                  value: price,
                },
              ],
            },
            paymentDetails: {
              communicationNumber: rtn,
              loginId: rtn,
              serviceInstance: rtn,
              orderAmount: numericPrice,
              undiscountedAmount: numericPrice,
              paymentLob: 'CART_ECOM',
              paymentMeta: {
                lob: 'CART_ECOM',
                postingLobs: [],
                rechargeOrBill: '1',
              },
            },
            appliedOffer: [],
          },
        },
        config: {
          redirectionURLOnPayment: thankYouPageUrlDeepLink,
        },
        bypassOrder: true,
      },
    },
  };

  return JSON.stringify(paymentObj);
};
